/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Detail_IdInputs */

const vi_receipt_detail_id = /** @type {(inputs: Receipt_Detail_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã phiếu`)
};

/**

* @param {Receipt_Detail_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_detail_id = /** @type {((inputs?: Receipt_Detail_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Detail_IdInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_detail_id(inputs)
});